function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

function checkOverflow(text) {
  if (text.dataset.overflow === "0") {
    let overflowing =
      text.scrollHeight > text.clientHeight ||
      text.scrollWidth > text.clientWidth;
    let overflow = text.scrollWidth - text.clientWidth;
    if (overflowing) {
      text.classList.add("ais-text--overflowing");
      text.dataset.overflow = overflow.toString();
    }
  }
}


function isProductTitleOverflowing(element) {
  let title = document.querySelector(
    ".ais-hit--title-" + element.dataset.handle
  );
  let subtitle = document.querySelector(
    ".ais-hit--subtitle-" + element.dataset.handle
  );
  let subtitle2 = document.querySelector(
    ".ais-hit--subtitle2-" + element.dataset.handle
  );
  checkOverflow(title);
  checkOverflow(subtitle);
  checkOverflow(subtitle2);
}

// Custom function by Kvalifik
// Allows variant selectors on embedded products to change currently selected variant.
// Changes price and image shown.
// Disabled until we re-enable embedded products
/*
const algolia_changeVariant = (image, title, id, price, handle, currentID) => {
  const variant = {
    'image': image,
    'title': title,
    'id':id,
    'price': price,
    'handle': handle
  }
  let currencySymbol = ""
  switch(Shopify.currency.active){
    case "EUR": currencySymbol = "€"; break;
    case "GBP": currencySymbol = "£"; break;
    case "USD": currencySymbol = "$"; break;
    case "RUB": currencySymbol = "₽"; break;  
    case "JPY": currencySymbol = "¥"; val = Math.round(val); break;
    case "CHF": currencySymbol = "CHF "; break;
    case "SEK": currencySymbol = "SEK"; val = Math.round(val); break;
    case "NOK": currencySymbol = "NOK"; break;
    case "DKK": currencySymbol = "DKK"; break;
    default: currencySymbol = "";
  }
  let convertedPrice = variant.price / 100

  let formattedPrice = currencySymbol + convertedPrice;
  if (currencySymbol == "NOK" || currencySymbol == "SEK" || currencySymbol == "DKK") formattedPrice = convertedPrice + " " + currencySymbol
  if (currencySymbol == "CHF") formattedPrice = "CHF " + convertedPrice

  // Get elements
  const aisHitPrice = document.getElementById(variant.handle + '--price')
  const aisHitVariantSelector = document.getElementById('js-variantSelector--' + variant.handle)

  // De-select currently active variant selector
  const aisHit__currentVariantButton = document.querySelector('.js-variant-selector-active--' + currentID)  
  aisHit__currentVariantButton.classList.remove('mikkeller__variantSelector--active')
  aisHit__currentVariantButton.classList.remove('js-variant-selector-active--' + currentID)
  
  // Select correct variant selector
  const aisHit__newVariantButton = document.querySelector('button[data-variant-id="' + variant.id + '"]')
  aisHit__newVariantButton.classList.add('mikkeller__variantSelector--active')
  aisHit__newVariantButton.classList.add('js-variant-selector-active--' + currentID)

  //Change Price
  aisHitPrice.innerHTML = formattedPrice;

  // Change selected variant, so we add the correct product to cart.
  aisHitVariantSelector.value = variant.id
}*/
